import RequestAuthTab_vue_vue_type_script_setup_true_lang_default from "./RequestAuthTab.vue.script.js";
//#region src/v2/blocks/scalar-auth-selector-block/components/RequestAuthTab.vue
var RequestAuthTab_default = RequestAuthTab_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { RequestAuthTab_default as default };

//# sourceMappingURL=RequestAuthTab.vue.js.map